let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7UEFe")).then(() => parcelRequire('dNosa'));